import { useMemo, useSyncExternalStore } from "react";
import { AuthService } from "@domain/services/auth.service";

export function useAuth() {
  const store = AuthService.getStore();
  const state = useSyncExternalStore(store.subscribe, store.getState);

  const user = useMemo(() => {
    return state.auth.state === "authenticated" ? state.auth.user : null;
  }, [state.auth]);

  return {
    auth: state.auth,
    user,
    login: AuthService.login.bind(AuthService),
    requestOtp: AuthService.register.bind(AuthService),
    updateUserInfo: AuthService.updateUserInfo.bind(AuthService),
    refreshUser: AuthService.refreshUser.bind(AuthService),
    logout: AuthService.logout.bind(AuthService)
  };
}
